import React, { useEffect } from "react";
import {
  Button,
  Grid,
  IconButton,
  InputAdornment,
  Table,
  TableBody,
  TableCell,
  TableRow,
  TextField,
} from "@material-ui/core";
import InputMask from "react-input-mask";
import dayjs from "dayjs";

import { SearchButton } from "components/searchButton";
import { ReactComponent as SearchIcon } from "assets/icons/search-white.svg";
import Calendar from "assets/icons/calendar.svg";
import { ReactComponent as Document } from "assets/icons/services-icons/document.svg";
import {
  CustomTableContainer,
  CustomTableHead,
  ExportText,
  TabTitle,
} from "../publications.styles";
// import { diaryPublications } from "mocked/diaryPublications";
import { usePublicationsState } from "../context/publications-context";
import { usePublicationsController } from "../context/publications-controller";
import { IOfficialDiaryPagedResponse } from "models/response/official-diary-paged-response";
import { Pagination } from "@material-ui/lab";
import CustomBackdrop from "components/backdrop";

export const DiaryTabContent = () => {
  const { officialDailyRequest, officialDailyResponse } = usePublicationsState();
  const { handleOnChange, listOfficialDaily, exportData } = usePublicationsController();

  const handlePageClick = (event: React.ChangeEvent<unknown>, value: number) => {
    window.scrollTo({ top: 0, behavior: "smooth" });

    (async () => {
      await listOfficialDaily({ ...officialDailyRequest, page: value - 1 }, true);
    })();
  };

  return (
    <>
      <Grid item xs={12}>
        <TabTitle>Diário oficial próprio</TabTitle>
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <TextField
                value={officialDailyRequest.term}
                variant="outlined"
                name="text-field-term"
                fullWidth
                onChange={(e) => handleOnChange(e, 1)}
                label="Buscar por"
              />
            </Grid>
            <Grid item xs={12} md>
              <InputMask
                mask={"99/99/9999"}
                name="text-field-start-date"
                autoComplete='off'

                onChange={(e) => handleOnChange(e, 1)}
                value={officialDailyRequest.startDate !== null ? officialDailyRequest.startDate : ""}
              >
                {(inputProps) => (
                  <TextField
                    variant="outlined"
                    fullWidth
                    label="Data início"

                    placeholder="dd/mm/aaaa"
                    {...inputProps}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="start">
                          <img src={Calendar} alt="" />
                        </InputAdornment>
                      ),
                    }}
                  />
                )}
              </InputMask>
            </Grid>
            <Grid item xs={12} md>
              <InputMask
                mask={"99/99/9999"}
                name="text-field-end-date"
                autoComplete='off'

                onChange={(e) => handleOnChange(e, 1)}
                value={officialDailyRequest.endDate != null ? officialDailyRequest.endDate : ""}
              >
                {(inputProps) => (
                  <TextField
                    variant="outlined"
                    fullWidth

                    label="Data fim"
                    placeholder="dd/mm/aaaa"
                    {...inputProps}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="start">
                          <img src={Calendar} alt="" />
                        </InputAdornment>
                      ),
                    }}
                  />
                )}
              </InputMask>
            </Grid>
            <Grid item xs="auto">
              <SearchButton onClick={() => (async () => {
                await listOfficialDaily(officialDailyRequest, true);

              })()}>
                <SearchIcon /> Consultar
              </SearchButton>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Grid
            container
            spacing={2}
            justifyContent="flex-end"
            alignItems="center"
          >
            <Grid item xs="auto">
              <ExportText>Exportar</ExportText>
            </Grid>
            <Grid item xs="auto">
              <Button startIcon={<Document />}
                onClick={() => (async () => {
                  await exportData(1, "odt");

                })()}>ODT</Button>
            </Grid>
            <Grid item xs="auto">
              <Button startIcon={<Document />} onClick={() => (async () => {
                await exportData(1, "json");

              })()}>JSON</Button>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>

          <CustomTableContainer>
            <Table>
              <CustomTableHead>
                <TableRow>
                  <TableCell width="12%">Data Publicação</TableCell>
                  <TableCell width="12%">Número Edição</TableCell>
                  <TableCell width="10%">Ano</TableCell>
                  <TableCell width="60%">Desrição</TableCell>
                  <TableCell width="10%">Edição Extra</TableCell>
                  <TableCell width="auto">Ver Diário</TableCell>
                </TableRow>
              </CustomTableHead>
              <TableBody>
                {officialDailyResponse &&
                  officialDailyResponse?.items?.map((item: IOfficialDiaryPagedResponse) => (
                    <TableRow key={item.id}>
                      <TableCell>{dayjs(item.publicationDate).format("DD/MM/YYYY")}</TableCell>
                      <TableCell>{item.editionNumber}</TableCell>
                      <TableCell>{item.yearPublication}</TableCell>
                      <TableCell>
                        <span
                          dangerouslySetInnerHTML={{
                            __html: item.description,
                          }}
                        />
                      </TableCell>
                      <TableCell>{item.isExtra ? "Sim" : "Não"}</TableCell>

                      <TableCell>
                        <IconButton onClick={() => window.open(item.fileUrl, "_blank")}>
                          <Document />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </CustomTableContainer>

        </Grid>
        <Grid item xs={12}>
          <Grid container justifyContent="center">
            <Pagination size="large" variant="outlined" shape="rounded" onChange={handlePageClick} count={officialDailyResponse.pageCount} color="primary" />
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};
